module.exports = __webpack_public_path__ + "static/media/1-Fuerstenberg-klein.ef8779a5.jpg";